import { Decorative } from "@faire/design-tokens";
import { Flex } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import {
  Section,
  SectionHeadline,
  LimitedSectionContent,
} from "@faire/retailer/views/careers/__internal__/common/common";

export const BelongingEmployeesCustomersSection: React.FC = () => {
  return (
    <Section
      $backgroundColor={Decorative.tint.neutral}
      $withHorizontalPadding
      $withVerticalPadding
      align="center"
    >
      <LimitedSectionContent>
        <RowToColumn>
          <HeadlineContainer>
            <SectionHeadline>
              <StrictLocalMsg
                defaultMessage="For our employees"
                description={{
                  text: "Section header line for our employees",
                  img: "https://cdn.faire.com/fastly/c16877790e6e143b239651a4cba4ad521820dd6f674aa1ebe90ae9e0aa24675e.png",
                }}
              />
            </SectionHeadline>
          </HeadlineContainer>
          <Spacer height={{ mobileAndAbove: "3x", desktopAndAbove: 0 }} />
          <BodyContainer>
            <Typography
              variant={{
                mobileAndAbove: "paragraphSansRegular",
                desktopAndAbove: "subheadingSansRegular",
              }}
            >
              <StrictLocalMsg
                defaultMessage={
                  "An inclusive work environment ensures that all Faire employees feel valued and have equal" +
                  " access to opportunities, professional growth, and success. We're committed to fostering a culture " +
                  "where all Faire employees can show up authentically and learn from one another through active listening."
                }
                description={{
                  text: "description for our employees sections",
                  img: "https://cdn.faire.com/fastly/c16877790e6e143b239651a4cba4ad521820dd6f674aa1ebe90ae9e0aa24675e.png",
                }}
              />
            </Typography>
          </BodyContainer>
        </RowToColumn>
        <Spacer height="8x" />
        <RowToColumn>
          <HeadlineContainer>
            <SectionHeadline>
              <StrictLocalMsg
                defaultMessage="For our customers"
                description={{
                  text: "Section header line for our customers",
                  img: "https://cdn.faire.com/fastly/c16877790e6e143b239651a4cba4ad521820dd6f674aa1ebe90ae9e0aa24675e.png",
                }}
              />
            </SectionHeadline>
          </HeadlineContainer>
          <Spacer height={{ mobileAndAbove: "3x", desktopAndAbove: 0 }} />
          <BodyContainer>
            <Typography
              variant={{
                mobileAndAbove: "paragraphSansRegular",
                desktopAndAbove: "subheadingSansRegular",
              }}
            >
              <StrictLocalMsg
                defaultMessage={
                  "As a global platform, we recognize that our product serves a diverse community of brands and retailers. " +
                  "That’s why we take a localized approach when entering new markets, and are committed to amplifying unique " +
                  "voices across our site through collection features, blog spotlights, and customer panels."
                }
                description={{
                  text: "description for our employees sections",
                  img: "https://cdn.faire.com/fastly/c16877790e6e143b239651a4cba4ad521820dd6f674aa1ebe90ae9e0aa24675e.png",
                }}
              />
            </Typography>
          </BodyContainer>
        </RowToColumn>
      </LimitedSectionContent>
    </Section>
  );
};

const RowToColumn = styled(Flex).attrs({
  direction: { mobileAndAbove: "column", desktopAndAbove: "row" },
})``;

const HeadlineContainer = styled.div`
  width: 400px;
  min-width: 350px;
`;

const BodyContainer = styled.div`
  max-width: 571px;
`;
